import { css } from '@emotion/css';

export const iconStyles = css`
  .emoji-mart-emoji {
    display: flex;
  }
`;
